export enum TitleLogRole
{
	StoreUser = 600,
	Manager = 601,
	DeskUser = 602,
	CorpUser = 603,
	RegionalManager = 605,
}
